require('./bootstrap');

// LOKALNE
require('./components/jquery.autocomplete');
require('./components/jquery.sticky');
require('./components/parallaxie');

window.Cookies = require('js-cookie/src/js.cookie');
window.Swiper = require('swiper/swiper-bundle');

require('flatpickr');
require('flatpickr/dist/l10n/pl').default.pl;
require('flatpickr/dist/l10n/sl').sl;

window.AOS = require('AOS');
AOS.init();

import Sortable, { MultiDrag, Swap } from 'sortablejs';
window.Sortable = Sortable;

import anime from 'animejs';
window.anime = anime;

import confetti from 'canvas-confetti';
window.confetti = confetti;

import Favico from 'favico.js'
window.Favico = Favico;

import mergeImages from 'merge-images'
window.mergeImages = mergeImages;

import SimpleLightbox from "simplelightbox";
window.SimpleLightbox = SimpleLightbox;

require('dropzone');
Dropzone.autoDiscover = false;

require('starrr/dist/starrr.js');

import Lang from 'lang.js'
window.lang = new Lang({
    messages: require( './components/translations'),
    fallback: 'en'
});

require('./core');
require('./pwa');

window.QRCode = require('easyqrcodejs/dist/easy.qrcode.min');
